import {
    createPlugin,
    createRoutableExtension,
} from "@backstage/core-plugin-api";
import {
    createFrontendModule,
    SubPageBlueprint,
} from "@backstage/frontend-plugin-api";

import { AdminContent } from "./components/AdminContent";
import { pluginId, rootRouteRef } from "./routes";

/** The primary admin frontend plugin. */
export const adminPlugin = createPlugin({
    id: pluginId,
    routes: {
        root: rootRouteRef,
    },
});

/** Routable extension for the top-level /admin page, gated by administerPermission. */
export const AdminPage = adminPlugin.provide(
    createRoutableExtension({
        name: "AdminPage",
        component: () => import("./views/AdminPage").then(m => m.AdminPage),
        mountPoint: rootRouteRef,
    })
);

/** Frontend module that adds an Admin sub-page to the DevTools plugin. */
export const adminDevToolsModule = createFrontendModule({
    pluginId: "devtools",
    extensions: [
        SubPageBlueprint.make({
            name: "admin",
            attachTo: { id: "page:devtools", input: "pages" },
            params: {
                path: "admin",
                title: "Admin",
                loader: () => Promise.resolve(<AdminContent />),
            },
        }),
    ],
});
